
export const styles = {
  markerInfoWindowContent: {
    minWidth: '100px',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  mapStyles: {
    maxHeight: 300,
    height: 300,
    width: '100%',
    borderRadius: '10px',
  },
};
